import { gql } from '@apollo/client'
import productsFieldsQuery from '../../commons/fields/products'

/**
 * Gets the string for `previouslyPurchasedQuery` query.
 * Returns products the current user has purchased in the past.
 * @internal
 */

const previouslyPurchasedQuery = gql`
  query PreviouslyPurchased(
    $storefrontName: String!,
    $sessionUid: ID!,
    $limit: Int
  ) {
    previouslyPurchased(
      storefrontName: $storefrontName,
      sessionUid: $sessionUid,
      limit: $limit
    ) {
      items {
        ${productsFieldsQuery}
      }
    }
  }
`

export default previouslyPurchasedQuery
